import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, toObservable } from "keautils";
import { observeResource } from "kea-resource";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";

class EsZonaExtAlert extends React.PureComponent<{ value: boolean }> {
    render() {
        return (
            this.props.value &&
            <div className="alert alert-info">
                <i className={fa("exclamation-circle")} />
                La entrega a domicilio se realizará en <b>zona extendida</b>
            </div>
        )
    }
}

export const EsZonaExtRx = componentToRx(EsZonaExtAlert);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/documentacion/componentes/eszonaext.tsx